import BaseImageStyles from '../BaseImage/BaseImage.styles';
import baseStyles from '../Base/Base.styles';
import basePlayButton from '../BasePlayButton/BasePlayButton.styles';
import merge from 'lodash/merge';
export default ({base, image, overlay, playButton}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '& .wrapper, & img': BaseImageStyles(image),
    },
  };

  if (overlay === 'playButton') {
    merge(jss.root, {
      '& .pb': basePlayButton(playButton),
    });
  }

  return jss;
};
